import { jsx as a, jsxs as b } from "react/jsx-runtime";
import d from "react";
import { cn as l } from "./index23.mjs";
import m from "./index26.mjs";
function h({ isTableFixed: e = !1, className: t, ...r }) {
  return /* @__PURE__ */ a("div", { "data-slot": "table-container", className: "relative w-full overflow-x-auto", children: /* @__PURE__ */ a(
    "table",
    {
      "data-slot": "table",
      className: l("w-full caption-bottom text-sm", e && "md:table-fixed", t),
      ...r
    }
  ) });
}
function N({ className: e, ...t }) {
  return /* @__PURE__ */ a("thead", { "data-slot": "table-header", className: l("[&_tr]:border-b", e), ...t });
}
function g({ className: e, zebra: t = !1, children: r, ...o }) {
  const n = d.Children.toArray(r);
  return /* @__PURE__ */ a("tbody", { "data-slot": "table-body", className: l("[&_tr:last-child]:border-0", e), ...o, children: n.map((s, c) => {
    const i = t && c % 2 === 0;
    return d.isValidElement(s) ? d.cloneElement(s, {
      className: l(
        i ? "bg-gray-100" : "",
        s.props.className
      )
    }) : s;
  }) });
}
function y({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: l("bg-muted/50 border-t font-medium [&>tr]:last:border-b-0", e),
      ...t
    }
  );
}
function w({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tr",
    {
      "data-slot": "table-row",
      className: l("data-[state=selected]:bg-muted border-b transition-colors", e),
      ...t
    }
  );
}
function T({
  className: e,
  columnKey: t,
  onSort: r,
  sortOrder: o,
  // eslint-disable-line @typescript-eslint/no-unused-vars
  align: n = "left",
  children: s,
  ...c
}) {
  const i = {
    left: "justify-start text-left",
    center: "justify-center text-center",
    right: "justify-end text-right"
  }[n];
  return /* @__PURE__ */ a(
    "th",
    {
      "data-slot": "table-head",
      className: l(
        "w-1/4 h-10 px-2 text-left align-middle font-semibold whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px] text-gray-900",
        r && "cursor-pointer",
        e
      ),
      onClick: () => t && (r == null ? void 0 : r(t)),
      ...c,
      children: /* @__PURE__ */ b("div", { className: l("flex gap-1 items-center", i), children: [
        s,
        r && /* @__PURE__ */ a(m, { sortOrder: o })
      ] })
    }
  );
}
function j({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "td",
    {
      "data-slot": "table-cell",
      className: l(
        "p-3 align-middle text-neutral-900 whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...t
    }
  );
}
function k({ className: e, ...t }) {
  return /* @__PURE__ */ a("caption", { "data-slot": "table-caption", className: l("text-muted-foreground mt-4 text-sm", e), ...t });
}
export {
  h as Table,
  g as TableBody,
  k as TableCaption,
  j as TableCell,
  y as TableFooter,
  T as TableHead,
  N as TableHeader,
  w as TableRow
};
